<div class="ag-custom-loading-cell" style="text-align: center;padding-left: 10px; line-height: 25px;">
  
  <span *ngIf="params"> {{params.value}} </span>
  <ng-container *ngIf="!params">
    <fa name="spinner"></fa>
  </ng-container>
</div>